import { render, staticRenderFns } from "./SupportedDronesCard.vue?vue&type=template&id=6c8de829&scoped=true&"
import script from "./SupportedDronesCard.vue?vue&type=script&lang=js&"
export * from "./SupportedDronesCard.vue?vue&type=script&lang=js&"
import style0 from "./SupportedDronesCard.vue?vue&type=style&index=0&id=6c8de829&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8de829",
  null
  
)

export default component.exports